import { Button as DevButton } from "devextreme-react/button";
import { useCallback, useEffect, useState } from "react";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { showNotify } from "../../../helpers/toast";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import Modal from "../../../components/ui/modal";
import { PlaceHolder } from "../../place-holder";
import styles from "./TaoBienLai.module.css";
import { ChecklistIcon, XIcon, CreditCardIcon, CopyIcon, DownloadIcon } from "@primer/octicons-react";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { formatVND } from "../../../utils/formatVND";

type ThuPhiTaoBienLaiBtnProps = {
  disabled: boolean;
  sf_mucphaithu: sf_mucphaithu;
  usePopupButton?: boolean;
  printType?: "bienlai" | "thongbaophi";
  buttonText?: string;
  ts_hocsinh?: any;
};

const ThuPhiTaoBienLaiBtn = (props: ThuPhiTaoBienLaiBtnProps) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const isThongBaoPhi = props.printType === "thongbaophi";
  const printButtonText = props.buttonText || (isThongBaoPhi ? "In thông báo phí" : "In biên lai");

  const handleOpenModal = useCallback(() => {
    setIsShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsShowModal(false);
  }, []);

  return (
    <>
      {props.usePopupButton ? (
        <Button
          variant="default"
          text={printButtonText}
          iconClass="fa fa-print"
          disabled={props.disabled}
          onClick={handleOpenModal}
        />
      ) : (
        <DevButton
          text={printButtonText}
          type="default"
          stylingMode="text"
          icon="print"
          className="p-btn-devextreme"
          disabled={props.disabled}
          onClick={handleOpenModal}
        />
      )}
      <Modal
        title={printButtonText}
        width="80%"
        isOpen={isShowModal}
        onClose={handleCloseModal}
      >
        <PrintModal
          sf_mucphaithu={props.sf_mucphaithu}
          printType={props.printType}
          onClose={handleCloseModal}
          ts_hocsinh={props.ts_hocsinh}
        />
      </Modal>
    </>
  );
};

type PrintModalProps = {
  sf_mucphaithu: sf_mucphaithu;
  printType?: "bienlai" | "thongbaophi";
  title?: string;
  onClose: () => void;
  ts_hocsinh?: any;
};

export const QRModalContent = (props: {
  sf_mucphaithu: sf_mucphaithu;
  ts_hocsinh?: any;
  onClose: () => void;
}) => {
  const [qrImageUrl, setQrImageUrl] = useState<string>("");
  const [qrLoading, setQrLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    const fetchQr = async () => {
      setQrLoading(true);
      try {
        const res = await mucPhaiThuApi.gen_qr({
          sf_mucphaithu_id: props.sf_mucphaithu.id
        });
        if (cancelled) return;
        if (res && res.is_success && res.data && res.data.qrImage) {
          setQrImageUrl(res.data.qrImage);
        } else {
          showNotify({ message: res.message || "Lỗi tạo mã QR", type: "warning" });
          props.onClose();
        }
      } catch (err: any) {
        if (cancelled) return;
        console.error(err);
        showNotify({ message: "Lỗi kết nối tới hệ thống QR", type: "error" });
        props.onClose();
      } finally {
        if (!cancelled) setQrLoading(false);
      }
    };
    fetchQr();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCopyText = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    showNotify({ message: `Đã sao chép ${label}`, type: "success" });
  };

  const handleDownloadQr = () => {
    if (!qrImageUrl) return;
    const link = document.createElement("a");
    link.href = qrImageUrl;
    link.download = `VietQR_${props.sf_mucphaithu.so_chung_tu}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={styles.qrContainer}>
      <div className={styles.qrTitle}>Mã QR Thanh toán</div>
      <div className={styles.qrSubtitle}>Sử dụng ứng dụng ngân hàng quét mã VietQR để thanh toán nhanh</div>

      {qrLoading ? (
        <div style={{ padding: "40px 0", textAlign: "center", width: "100%" }}>
          <PlaceHolder line_number={5} />
          <div style={{ marginTop: "12px", color: "#586069" }}>Đang khởi tạo mã QR thanh toán...</div>
        </div>
      ) : (
        <>
          <div className={styles.qrImageSection}>
            {qrImageUrl ? (
              <img src={qrImageUrl} alt="VietQR" className={styles.qrImage} />
            ) : (
              <div style={{ color: "#d73a49", padding: "20px 0" }}>Không thể tạo mã QR. Vui lòng thử lại.</div>
            )}
            {qrImageUrl && (
              <button className={styles.downloadButton} onClick={handleDownloadQr}>
                <DownloadIcon /> Tải ảnh QR
              </button>
            )}
          </div>

          <div className={styles.qrDetailsSection}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Học sinh</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue}>
                  {props.ts_hocsinh?.ho_ten || (props.sf_mucphaithu as any).ho_ten || ""} ({props.ts_hocsinh?.ma_hs || (props.sf_mucphaithu as any).ma_hs || ""})
                </span>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Số tiền cần nộp</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontWeight: "bold", color: "#cf222e" }}>
                  {formatVND(props.sf_mucphaithu.tong_tien_phai_nop - props.sf_mucphaithu.tong_tien_da_nop)} đ
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText(
                    Math.max(0, Math.floor(props.sf_mucphaithu.tong_tien_phai_nop - props.sf_mucphaithu.tong_tien_da_nop)).toString(),
                    "số tiền"
                  )}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Nội dung chuyển khoản</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue}>
                  {props.sf_mucphaithu.noi_dung || `Thanh toan CT ${props.sf_mucphaithu.so_chung_tu}`}
                </span>
                <button
                  className={styles.copyButton}
                  onClick={() => handleCopyText(
                    props.sf_mucphaithu.noi_dung || `Thanh toan CT ${props.sf_mucphaithu.so_chung_tu}`,
                    "nội dung"
                  )}
                >
                  <CopyIcon size={14} /> Sao chép
                </button>
              </div>
            </div>

            <div className={styles.detailRow} style={{ borderBottom: "none" }}>
              <span className={styles.detailLabel}>Cổng thanh toán</span>
              <div className={styles.detailValueContainer}>
                <span className={styles.detailValue} style={{ fontSize: "13px", color: "#586069" }}>
                  BIDV VietQR (Thu hộ học phí tự động)
                </span>
              </div>
            </div>
          </div>

          <ModalActions>
            <Button
              variant="default"
              leadingVisual={XIcon}
              text="Đóng"
              onClick={props.onClose}
            />
          </ModalActions>
        </>
      )}
    </div>
  );
};

export const ThuPhiQRBtn = (props: {
  disabled?: boolean;
  sf_mucphaithu: sf_mucphaithu;
  ts_hocsinh?: any;
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const handleOpenModal = useCallback(() => {
    setIsShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsShowModal(false);
  }, []);

  return (
    <>
      <DevButton
        text="Mã QR Thanh toán"
        type="default"
        stylingMode="text"
        icon="money"
        className="p-btn-devextreme"
        disabled={props.disabled}
        onClick={handleOpenModal}
      />
      {isShowModal && (
        <Modal
          title="Mã QR Thanh toán BIDV"
          width="xlarge"
          isOpen={isShowModal}
          onClose={handleCloseModal}
        >
          <QRModalContent
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh={props.ts_hocsinh}
            onClose={handleCloseModal}
          />
        </Modal>
      )}
    </>
  );
};

export const PrintModal = (props: PrintModalProps) => {
  const [print_url, set_print_url] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isShowQrModal, setIsShowQrModal] = useState<boolean>(false);

  useEffect(() => {
    handleFetchData();
  }, [props.sf_mucphaithu.id]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "p") {
        e.preventDefault();
        handlePrint();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [print_url]);

  const handleFetchData = async () => {
    setIsLoading(true);
    const isPhaithuGoc = props.sf_mucphaithu.so_chung_tu.includes("CT") || props.sf_mucphaithu.so_chung_tu.includes("RV");
    const data_send: any = {
      sf_mucphaithu_id: isPhaithuGoc
        ? props.sf_mucphaithu.id
        : props.sf_mucphaithu.sf_mucphaithu_parent_id,
      sf_mucphaithu_root_id: props.sf_mucphaithu.id,
    };
    const res = props.printType === "thongbaophi"
      ? await bienLaiThuApi.print_thongbaophi(data_send)
      : await bienLaiThuApi.print(data_send);
    if (res.is_success) {
      set_print_url(res.data);
    } else {
      set_print_url("");
      showNotify({ message: res.message || "Không tải được dữ liệu in", type: "warning" });
    }
    setIsLoading(false);
  };

  const handlePrint = () => {
    const iframe = document.getElementById("iframe_print_preview") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } else {
      window.print();
    }
  };

  return (
    <div className={styles.custom_width}>
      <div style={{ padding: "0 10px" }}>
        {isLoading && <PlaceHolder line_number={20} />}
        {!isLoading && (
          <div id="embed_print_bienlai_container">
            <iframe
              id="iframe_print_preview"
              srcDoc={`
                  <html>
                    <head>
                      <style>
                        @media print {
                          * {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                          }
                        }
                      </style>
                    </head>
                    <body>
                      ${print_url}
                      <script>
                        window.addEventListener("keydown", (e) => {
                          if ((e.ctrlKey || e.metaKey) && e.key === "p") {
                            e.preventDefault();
                            window.print();
                          }
                        });
                      </script>
                    </body>
                  </html>
                `}
              width="100%"
              height={window.innerHeight - 210}
              title={props.title || "Xem trước"}
              style={{ border: "1px solid #ddd", borderRadius: "4px" }}
            ></iframe>
          </div>
        )}
        <ModalActions>
          <Button
            variant="default"
            leadingVisual={XIcon}
            text="Đóng"
            onClick={props.onClose}
          />
          <Button
            variant="default"
            leadingVisual={CreditCardIcon}
            text="Mã QR Thanh toán"
            onClick={() => setIsShowQrModal(true)}
          />
          <Button
            variant="primary"
            leadingVisual={ChecklistIcon}
            text={props.printType === "thongbaophi" ? "In thông báo phí" : "In biên lai"}
            onClick={handlePrint}
            isLoading={isLoading}
            disabled={!print_url}
          />
        </ModalActions>
      </div>

      {isShowQrModal && (
        <Modal
          title="Mã QR Thanh toán BIDV"
          width="xlarge"
          isOpen={isShowQrModal}
          onClose={() => setIsShowQrModal(false)}
        >
          <QRModalContent
            sf_mucphaithu={props.sf_mucphaithu}
            ts_hocsinh={props.ts_hocsinh}
            onClose={() => setIsShowQrModal(false)}
          />
        </Modal>
      )}
    </div>
  );
};

export default ThuPhiTaoBienLaiBtn;
